import { render, staticRenderFns } from "./ReportsWireCheck.vue?vue&type=template&id=4daf624f"
import script from "./ReportsWireCheck.vue?vue&type=script&lang=js"
export * from "./ReportsWireCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports